import { render } from "./TableItem.vue?vue&type=template&id=555af8ce&scoped=true"
import script from "./TableItem.vue?vue&type=script&lang=ts"
export * from "./TableItem.vue?vue&type=script&lang=ts"

import "./TableItem.vue?vue&type=style&index=0&id=555af8ce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-555af8ce"

export default script